/**
 * @Description 详情
 */

import { FC, forwardRef, useContext, useImperativeHandle, useState } from 'react';
import { Button, Form, Space } from 'antd';
import V2Container from '@/common/components/Data/V2Container';
import { useMethods } from '@lhb/hook';
import EditMain from './components/EditMain';
import styles from './index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import dayjs from 'dayjs';
import { getCookie } from '@lhb/cache';
import { postExpansionClusterAndDirectTaskCreate } from '@/common/api/expandStore/clusterAndDirect';
import { getFranchiseeDetail } from '@/common/api/expandStore/franchisee';
import { useSelector } from 'react-redux';
import { AssignType } from '@/common/components/business/ExpandStore/ts-config';
import UserInfoContext from '@/layout/context';
import { globalExpansionTaskAlias } from '@/common/utils/ways';

// const Detail: FC<any> = forwardRef(({ id, onClose }, ref) => {
const Detail: FC<any> = forwardRef(({
  onClose,
  reload,
  businessInfo,
  isBusiness,
  franchiseeId,
  isFromFranchisee,
  franchiseeAlias,
}, ref) => {
  const [innerMainHeight, setInnerMainHeight] = useState<number>(0);

  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [franchiseeDetail, setFranchiseeDetail] = useState<any>({});
  const [form] = Form.useForm();
  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  const isAssignTypeLeader = [AssignType.Twice, AssignType.ThreeTimes].includes(tenantCheckData?.taskAssignType); // 是否指派主管（二次、三次指派兼容为同样处理）
  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息
  const expansionTaskAlias = globalExpansionTaskAlias(globalAliasItemVOs);

  useImperativeHandle(ref, () => ({
    init: methods.init
  }));

  const methods = useMethods({

    /**
     * @description 初始化
     */
    init: () => {
      methods.loadData();
      isFromFranchisee && methods.loadFranchiseeData(franchiseeId);
    },

    loadData: async () => {
      // 之前这里执行了获取门店详情接口/standard/shop/detail，却没有使用返回数据。已删除处理。
    },

    loadFranchiseeData: async (id: number) => {
      if (!id) return;
      const data = await getFranchiseeDetail({ id });
      setFranchiseeDetail(data);
    },
    /**
     * @description 重新加载
     * @param status 状态 true 需要加载详情， false 不需要加载详情
     * @return
     */
    reload(status = true) {
      if (status) methods.init();

      reload?.();
    },

    onCancel() {
      form?.resetFields();
      onClose?.();
    },
    onSubmit() {
      form.validateFields().then(({ radio, assignAccountIds, managerId, targetAddress, ...values }) => {
        let assignAccount: any[] = [];

        if (radio === 1) {
          const accountId = getCookie('employeeId');
          assignAccount = [accountId];
        } else if (radio === 2) {
          if (isAssignTypeLeader) {
            if (!managerId) {
              V2Message.warning('请选择开发主管');
              return;
            }
          } else if (assignAccountIds) {
            assignAccount = [assignAccountIds];
          } else {
            V2Message.warning('请选择指派的团队成员');
            return;
          }
        } else {
          V2Message.warning('请选择指派的成员');
          return;
        }
        if (targetAddress && !targetAddress[1]) {
          V2Message.warning('城区请选择到市');
          return;
        }
        try {
          setSubmitLoading(true);
          const {
            name,
            emergencyDegree,
            expectDropInDate,
          } = values;
          const circleBusinessId = form.getFieldValue('circleBusinessId');
          // 构建目标城市参数
          const targetAddNew = targetAddress && {
            targetProvinceId: targetAddress[0] || undefined,
            targetCityId: targetAddress[1] || undefined,
            targetDistrictId: targetAddress[2] || undefined,
          };
          const params: any = {
            ...values,
            name,
            expectDropInDate: expectDropInDate && dayjs(expectDropInDate).format('YYYY-MM-DD'),
            emergencyDegree,
            ...targetAddNew,
            modelClusterId: circleBusinessId,
          };
          // 指派自己、或者指派其他成员时传assignAccountIds，指派主管用managerId
          Object.assign(params, radio === 2 && isAssignTypeLeader ? { managerId } : {
            assignAccountIds: assignAccount,
          });
          postExpansionClusterAndDirectTaskCreate(params).then(() => {
            V2Message.success('创建拓店任务成功');
            onClose?.();
            reload?.();
          })
            .catch((err) => {
              onClose?.();
              console.log('catch 失败', err);
              V2Message.error('创建拓店任务失败');
            }).finally(() => {
              setSubmitLoading(false);
            });
        } catch (error) {
          console.log('error', error);
          onClose?.();
          setSubmitLoading(false);
        }
      }, (err: any) => {
        if (err?.errorFields?.length) {
          V2Message.error(err?.errorFields[0].errors[0]);
        }
      });
    }
  });



  return (<>
    <V2Container
      emitMainHeight={(h) => setInnerMainHeight(h)}
      extraContent={{
        top: (<V2Title type='H1' text={`创建${expansionTaskAlias || '拓店任务'}`} />),
        bottom: (<Space className={styles.bottom} size={24}>
          <Button type='default' onClick={methods.onCancel}>取消</Button>
          <Button type='primary' onClick={methods.onSubmit} loading={submitLoading}>确定</Button>
        </Space>)
      }}
      style={{ height: 'calc(100vh - 48px)', width: '100%' }}
      className={styles.container}>
      <EditMain
        form={form}
        businessInfo={businessInfo}
        isBusiness={isBusiness}
        franchiseeDetail={franchiseeDetail}
        isFromFranchisee={isFromFranchisee}
        franchiseeAlias={franchiseeAlias}
        taskAssignType={tenantCheckData?.taskAssignType}
        taskAssignRoleIds={tenantCheckData?.taskAssignRoleIds}
        expansionTaskAlias={expansionTaskAlias}
        style={{
          height: innerMainHeight || 'auto',
          overflowY: 'scroll',
          overflowX: 'hidden',
          marginTop: '16px',
        }}/>
    </V2Container>
  </>);
});

export default Detail;
